import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { LinksBuild } from '@/data/types';
import { cn } from '@/lib/utils';

/**
 * Os dois downloads de uma versão: o instalador (equipe/servidor) e o
 * instalador cliente (estações). Link ausente não some — fica desabilitado com
 * o motivo, para ninguém procurar o botão que "devia estar ali".
 */
export function DownloadLinks({
  links,
  versao,
  tamanho = 'sm',
  className,
}: {
  links: LinksBuild;
  versao: string;
  tamanho?: 'sm' | 'md';
  className?: string;
}) {
  const itens = [
    { chave: 'instalador', rotulo: 'Instalador', url: links.instalador },
    { chave: 'instalador_cliente', rotulo: 'Instalador cliente', url: links.instalador_cliente },
  ];
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {itens.map((item) =>
        item.url ? (
          <Button key={item.chave} asChild variant="outline" size={tamanho}>
            <a href={item.url} download aria-label={`Baixar ${item.rotulo.toLowerCase()} da versão ${versao}`}>
              <Download aria-hidden="true" />
              {item.rotulo}
            </a>
          </Button>
        ) : (
          <Button
            key={item.chave}
            variant="outline"
            size={tamanho}
            disabled
            title={`A versão ${versao} não tem link de ${item.rotulo.toLowerCase()} publicado.`}
          >
            <Download aria-hidden="true" />
            {item.rotulo}
          </Button>
        ),
      )}
    </div>
  );
}
